// Auth Types
export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGOUT_USER = "LOGOUT_USER"

export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN"

export const GET_USER_INFORMATIONS = "GET_USER_INFORMATIONS"
export const USER_INFORMATIONS_SUCCESS = "USER_INFORMATIONS_SUCCESS"
export const UPDATE_ONBOARDING = "UPDATE_ONBOARDING"

export const CHANGE_LOGIN_LANGUAGE = "CHANGE_LOGIN_LANGUAGE"

export const SEND_EMAIL_RESET_PASSWORD = "SEND_EMAIL_RESET_PASSWORD"
export const LOGIN_KEYCLOAK = "LOGIN_KEYCLOAK"

export const SET_INFOS_MULTI_BUSINESS = "SET_INFOS_MULTI_BUSINESS"

export const SET_CURRENT_USER = "SET_CURRENT_USER"

export const SET_FIREWALL_BLOCKED = "SET_FIREWALL_BLOCKED"

export const MFA_REQUIRED = "MFA_REQUIRED"
export const MFA_CLEAR = "MFA_CLEAR"
